export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_sk.f608bb74df0c4a5d.json"